module.exports = __webpack_public_path__ + "static/media/comment.66f7677c.svg";